import axios from 'axios';
import { useAuthStore } from '../stores/auth';
import { ElMessage } from 'element-plus';
import { url } from '../assets/js/version';

// 统一 axios 封装（整合原 apiRequestHandler）
const api = axios.create({
  baseURL: url,
  timeout: 100000,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use(config => {
  const authStore = useAuthStore();
  if (authStore.token) {
    config.headers.Authorization = `Bearer ${authStore.token}`;
  }
  // 兼容代理模式 merchantId 透传
  const agentMerchantId = sessionStorage.getItem('agentMerchantId');
  if (agentMerchantId) {
    config.headers.MerchantId = agentMerchantId;
  }
  // 加入随机参数避免部分接口缓存（保留原逻辑）
  if (config.url && !config.url.includes('r=')) {
    const sep = config.url.includes('?') ? '&' : '?';
    config.url = `${config.url}${sep}r=${Math.floor(Math.random() * 100000) + 1}`;
  }
  return config;
});

api.interceptors.response.use(
  resp => {
    return {
      status: resp.status,
      data: resp.data,
      headers: resp.headers,
      raw: resp
    };
  },
  error => {
    const status = error.response?.status;
    // 统一提取后端 message，避免界面出现通用的 axios 错误文案
    const backendMessage = error.response?.data?.message || error.response?.data?.Message;
    if (backendMessage) {
      // 覆盖原始 message，方便直接使用 err.message
      error.message = backendMessage;
    }
    if (status === 401 || status === 403) {
      // 记录当前访问路径用于登录后返回（仅在非登录页时）
      try {
        const currentHash = window.location.hash || '';
        if (currentHash && !currentHash.includes('/dashboard/login')) {
          sessionStorage.setItem('returnUrl', currentHash.replace('#', ''));
        }
      } catch { /* ignore storage error */ }
      const authStore = useAuthStore();
      authStore.logout();
      if (status === 401) {
        // 未授权或 token 失效
        // 可选提示：ElMessage.error('登录已过期，请重新登录');
      } else if (status === 403) {
        // 无权限访问
        // 可选提示：ElMessage.error('无权限访问该资源');
      }
      window.location.hash = '#/dashboard/login';
    } else if (status === 423) {
      window.location.hash = '#/accessdenied';
    }
    return Promise.reject(error);
  }
);

export default api;
